import React, { useEffect, useState } from 'react';
import api from '../../services/api';
import { Link } from 'react-router-dom';
import { format } from 'date-fns';

export default function DeptPendingAlerts() {
  const [apps, setApps]     = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/reports/pending-overdue?days=7')
      .then(r => setApps(r.applications || []))
      .finally(() => setLoading(false));
  }, []);

  const urgencyColor = (days) => {
    if (days >= 30) return 'border-red-400 bg-red-50';
    if (days >= 14) return 'border-orange-400 bg-orange-50';
    return 'border-yellow-400 bg-yellow-50';
  };

  return (
    <div>
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-800">⏰ Pending Alerts</h1>
        <p className="text-sm text-gray-500 mt-1">
          Applications pending at your department for more than 7 days
        </p>
      </div>

      {loading ? (
        <div className="flex justify-center py-20">
          <div className="animate-spin w-8 h-8 border-2 border-yellow-400 border-t-transparent rounded-full" />
        </div>
      ) : apps.length === 0 ? (
        <div className="card text-center py-16">
          <p className="text-5xl mb-3">✅</p>
          <p className="text-lg font-semibold text-green-700">All Clear!</p>
          <p className="text-sm text-gray-400 mt-1">No applications pending for more than 7 days</p>
        </div>
      ) : (
        <>
          <div className="p-4 bg-orange-50 border border-orange-200 rounded-xl mb-4 text-sm text-orange-800">
            ⚠️ <strong>{apps.length} application(s)</strong> have been pending at your department for more than 7 days. Please take action.
          </div>
          <div className="space-y-3">
            {apps.map(app => (
              <div key={app.id} className={`card border-l-4 ${urgencyColor(app.days_pending)}`}>
                <div className="flex items-center justify-between flex-wrap gap-3">
                  <div>
                    <div className="flex items-center gap-2 mb-1">
                      <span className="font-mono text-xs text-blue-700 bg-blue-50 px-2 py-0.5 rounded font-semibold">
                        {app.application_no}
                      </span>
                      <span className={`text-xs font-bold px-2 py-0.5 rounded-full border ${
                        app.days_pending >= 30 ? 'bg-red-100 text-red-700 border-red-300' :
                        app.days_pending >= 14 ? 'bg-orange-100 text-orange-700 border-orange-300' :
                        'bg-yellow-100 text-yellow-700 border-yellow-300'
                      }`}>
                        {app.days_pending} days pending
                      </span>
                    </div>
                    <p className="font-semibold text-gray-800">{app.noc_name}</p>
                    <p className="text-sm text-gray-500">
                      👤 {app.applicant_name}
                      {app.applicant_mobile && <span className="ml-2">📱 {app.applicant_mobile}</span>}
                    </p>
                    <p className="text-xs text-gray-400 mt-0.5">
                      Submitted: {app.submitted_at ? format(new Date(app.submitted_at), 'dd MMM yyyy') : '—'}
                    </p>
                  </div>
                  <Link to={`/dept/applications/${app.id}`}
                    className="btn-primary text-sm flex-shrink-0">
                    Review Now →
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
}